import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../store";
import { setCurrentOps } from "../store/slices/opsSlice";
import { OpsType } from "../types";

export function useOps() {
  const dispatch = useAppDispatch();
  const { currentOps, availableOps, opsConfigs } = useAppSelector(
    (state) => state.ops
  );

  const switchOps = useCallback(
    (ops: OpsType) => {
      if (availableOps.includes(ops)) {
        dispatch(setCurrentOps(ops));
        localStorage.setItem("currentOps", ops);
      }
    },
    [dispatch, availableOps]
  );

  const getCurrentOpsConfig = useCallback(() => {
    if (!currentOps) return null;
    return opsConfigs[currentOps] || null;
  }, [currentOps, opsConfigs]);

  const getOpsConfig = useCallback(
    (ops: OpsType) => {
      return opsConfigs[ops] || null;
    },
    [opsConfigs]
  );

  const hasMultipleOps = availableOps.length > 1;

  return {
    currentOps,
    availableOps,
    switchOps,
    getCurrentOpsConfig,
    getOpsConfig,
    hasMultipleOps,
  };
}
